import React, { Component } from "react";
import axios from 'axios';
import api from '../api';
import Typography from '@material-ui/core/Typography';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import { withStyles } from "@material-ui/core/styles";
import MenuItem from '@material-ui/core/MenuItem';
import Button from '@material-ui/core/Button';
import Tooltip from '@material-ui/core/Tooltip';
import ViewIcon from '@material-ui/icons/Visibility';
import DeleteIcon from '@material-ui/icons/Delete';

const useStyles = theme => ({
  menu:{
      fontSize:'0.75rem',
  }
});

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

class Relations extends React.Component {
    constructor(props) {
      	super(props);
		this.state = {
			relations:[],
			work_order_types:[],
			work_order_type_id:'',
			work_order_to_id: '',
			work_order_relation_type_id: '',
			loading: true
		}
  	}

    async componentDidMount() {
    	var relations = this.props.relations
    	this.getWorkOrderTypes()
    	this.setState({relations: relations, loading: false, work_order_type_id: ''})
    }


    getWorkOrderTypes = async () => {
		const token = localStorage.getItem('userToken')
		return await axios
	     .get(api.dropdowns().ot(),{ headers: {"Authorization" : `Bearer ${token}`} })
	      .then(res => {
	      		var work_order_types = res.data.work_order_types
	      		this.setState({work_order_types: work_order_types})
	      })
	      .catch(err =>{console.log(err)
	      })
    }

    handleChange = (e) => {
    	this.setState({[e.target.name]: e.target.value})
    }


    handleSubmit = () => {
		this.setState({loading: true})
	    var formData = new FormData();
	    var url = api.relations().post();
	    formData.set("relation[work_order_from_id]", this.props.id);
	    formData.set("relation[work_order_to_id]", this.state.work_order_to_id);
	    formData.set("relation[work_order_relation_type_id]", this.state.work_order_relation_type_id);
	    let self = this
	    const token = localStorage.getItem('userToken')
	    axios.post(url,
	       formData,
	       {headers: {'Content-Type': 'multipart/form-data',"Authorization" : `Bearer ${token}`}}
	       )
	      .then((response)=> {
		  		self.setState({
		  			openSuccess: true,
		  			success_message: 'Relación cargada con éxito', 
		  			severity:'success', 
					loading: false,
					work_order_type_id: ''
				})

	      })
	      .catch(function (error) {
	      		var error_message = ''
	      		if (error.response.data.errors){
	      			if (error.response.data.errors['relation.work_order_to_id']){
	      				error_message = error.response.data.errors['relation.work_order_to_id'][0]
	      			} else {
	      				error_message = error.response.data.errors['relation.work_order_relation_type_id'][0]
	      			}
	      		} else {
	      			error_message = 'Ha ocurrido un error al cargar la relación. Por favor contacté a su adminsitrador'
	      		}
		  		self.setState({
		  			openSuccess: true,
		  			success_message: error_message, 
		  			severity:'warning',
					loading: false,
					work_order_type_id: ''
				})
	    })

    }

    remove = (id) =>{
		this.setState({loading: true})
	    var url = api.relations().remove(id);
	    let self = this
	    const token = localStorage.getItem('userToken')
	    axios.delete(url,
	       {headers: {'Content-Type': 'multipart/form-data',"Authorization" : `Bearer ${token}`}}
	       )
	      .then((response)=> {
	      		var relations = []
	      		this.state.relations.map((val,idx)=>{
	      			if (val.id !== id){
	      				relations.push(val)
	      			}
	      		})
		  		self.setState({
		  			relations: relations,
		  			openSuccess: true,
		  			success_message: 'Relación eliminada con éxito', 
		  			severity:'success',
					loading: false,
					work_order_type_id: ''

				})

	      })
	      .catch(function (error) {
		      	var error = (error.response.data.errors) ? error.response.data.errors['relation.id'][0] : 'Ha ocurrido un error al eliminar la relación. Por favor contacte a su adminsitrador'
		  		self.setState({
		  			openSuccess: true,
		  			success_message: error, 
		  			severity:'warning',
					loading: false,
					work_order_type_id: ''

				})
	    })

    }

    duplicate = () => {
		this.setState({loading: true})
	    var formData = new FormData();
	    var url = api.relations().duplicate(this.props.id);
	    let self = this
	    const token = localStorage.getItem('userToken')
	    formData.set('work_order[work_order_type_id]', this.state.work_order_type_id)
	    formData.set('work_order[id]', this.props.id)
	    axios.post(url,
	       formData,
	       {headers: {'Content-Type': 'multipart/form-data',"Authorization" : `Bearer ${token}`}}
	       )
	      .then((response)=> {
				window.open("/work-order/"+ response.data.work_order.id, "_blank")		  		
		  		self.setState({
		  			openSuccess: true,
		  			success_message: 'OT duplicada éxito', 
		  			severity:'success',
					loading: false,
					work_order_type_id: ''
				})

	      })
	      .catch(function (error) {
			var error_message = 'Ha ocurrido un error al duplicar la OT.'
			var errors = error.response.data
			if (errors.errors){
				if (errors.errors.status_code !== 404){
					var keys = Object.keys(errors.errors); 
					for(var i = 0; i < keys.length; i++) {   
					var key = (keys[i]) ; 
					var key_errors = errors.errors[key]
					error_message = '';
					key_errors.map((val,idx)=>{
						error_message = error_message.concat(val).concat(' ')
					})
					}
				} else {
					error_message = error_message.concat(errors.errors.message).concat(' ')
				}
			}
			self.setState({openSuccess: true, success_message: error_message, severity: 'warning', loading: false, work_order_from_id: ''})
	    })
    }

	render() {
		const classes = this.props.classes;
		return (
			<React.Fragment>
				<Snackbar open={this.state.openSuccess} autoHideDuration={10000} onClose={this.handleCloseSuccess}>
					<Alert onClose={this.handleCloseSuccess} severity={this.state.severity}>
					  {this.state.success_message}
					</Alert>
				</Snackbar>
				<div className="row mb-2 mt-2">
					<div className="col-8 mt-2">
						<Table size="small" aria-label="a dense table" style={{width: 'auto', minWidth:'650px'}}>
					        <TableHead>
					          <TableRow>
					            <TableCell style={{fontWeight: '550'}} >Nro OT</TableCell>
					            <TableCell style={{fontWeight: '550'}} >Tipo OT</TableCell>
					            <TableCell style={{fontWeight: '550'}} >Relacion</TableCell>
					            <TableCell style={{fontWeight: '550'}} >Fecha de alta</TableCell>
					            <TableCell style={{fontWeight: '550'}} >&nbsp;</TableCell>
					          </TableRow>
					        </TableHead>
					        <TableBody>
					        	{this.state.relations.map((val,idx)=>{
					        		var relation_id = (val.work_order_to_id === this.props.id) ? val.work_order_from_id : val.work_order_to_id
					        		var work_order_type_name = (val.work_order_to_id === this.props.id) ? val.work_order_from_type : val.work_order_to_type
					        		return (
							            <TableRow key={idx}>
								            <TableCell className="" style={{fontSize: '0.75rem'}} >{relation_id}</TableCell>
								            <TableCell className="" style={{fontSize: '0.75rem'}} >{work_order_type_name}</TableCell>
								            <TableCell className="" style={{fontSize: '0.75rem'}} >{val.type}</TableCell>
								            <TableCell className="" style={{fontSize: '0.75rem'}} >{val.created_at}</TableCell>
								            <TableCell>
								            	<Tooltip title="Ver OT" aria-label="ver_ot"><ViewIcon onClick={()=>window.open("/work-order/"+relation_id, "_blank")}/></Tooltip>
								            	<Tooltip title="Borrar relación" aria-label="ver_ot"><DeleteIcon onClick={(e)=>this.remove(val.id)} disabled={(this.state.disabled) ? true : false}/></Tooltip>
								            </TableCell>
							            </TableRow>
				        			)
					        	})}
					        </TableBody>
						</Table>
					</div>
					<div className="col-4 mt-2">
						<Typography variant="subtitle2" >Nueva relación</Typography>
						<TextField
							id="work_order_to_id"
							name="work_order_to_id"
							margin="normal"
							className="mr-2 mt-1"
							InputLabelProps={{
								shrink: true
							}}
			 			  	onChange={this.handleChange}
							value={this.state.work_order_to_id}
							inputProps={{style:{width: 50, fontSize: '0.75rem'}}}
						  	InputProps={{
						        startAdornment: <InputAdornment position="start" ><Typography variant="caption" >OT #	</Typography></InputAdornment>,
							}}
						/>
				       <TextField
							id="work_order_relation_type_id"
							name="work_order_relation_type_id"
							select
							margin="normal"
							className="mr-2 mt-1"
							InputLabelProps={{
								shrink: true
							}}
			 			  	onChange={this.handleChange}
						    value={this.state.work_order_relation_type_id}
							inputProps={{style:{minWidth: 70, fontSize: '0.75rem'}}}
				          	InputProps={{
					            startAdornment: <InputAdornment position="start" ><Typography variant="caption" style={{width: 75}}>Relación</Typography></InputAdornment>,
					            style:{fontSize: '0.75rem'}
								}}
				        >
				          {this.props.work_order_relation_types.map((option) => (
				            <MenuItem key={option.id} value={option.id} className={classes.menu}>
				              {option.name}
				            </MenuItem>
				          ))}
				        </TextField>

						<Button disabled={((this.state.work_order_relation_type_id !== '' && this.state.work_order_to_id !=='') && !this.state.loading ) ? false : true } className="mt-1" variant="contained" color="primary" size="small" style={{fontSize: '0.75rem'}} onClick={(e)=>{this.handleSubmit(e)}}>Cargar</Button>
						
						<div>
							<TextField
								id="work_order_type_id"
								name="work_order_type_id"
								select
								margin="normal"
								className="mr-2 mt-1"
								InputLabelProps={{
									shrink: true
								}}
								  	onChange={this.handleChange}
								value={this.state.work_order_type_id}
								inputProps={{style:{minWidth: 70, fontSize: '0.75rem'}}}
									InputProps={{
								    startAdornment: <InputAdornment position="start" ><Typography variant="caption" style={{width: 75}}>Tipo de OT</Typography></InputAdornment>,
								    style:{fontSize: '0.75rem'}
									}}
								>
								{this.state.work_order_types.map((option) => (
								<MenuItem key={option.id} value={option.id} className={classes.menu}>
								  {option.name}
								</MenuItem>
							))}
							</TextField>
							<Button disabled={(this.state.work_order_type_id !== '' && !this.state.loading) ? false : true} className="mt-1" variant="contained" color="primary" size="small" style={{fontSize: '0.75rem'}} onClick={(e)=>{this.duplicate(e)}}>Duplicar</Button>
						</div>
					</div>
				</div>
			</React.Fragment>
		)
	}

}

export default withStyles(useStyles)(Relations);

